// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2VqZ_","disabled":"FileBtn_disabled__1rJKo","warn":"FileBtn_warn__2bgYX","fade":"FileBtn_fade__3sQwO"};